import { useEffect, useState } from "react";

// TES-1074 point 5 — a trend point opens the check-in it came from. The
// anchor is shared so the link and the target cannot drift apart.

export function checkinAnchor(submissionId: string): string {
  return `incheckning-${submissionId}`;
}

function hashIs(anchor: string): boolean {
  return typeof window !== "undefined" && window.location.hash === `#${anchor}`;
}

/** True while the page's hash names `anchor`; follows later hash changes. */
export function useHashTarget(anchor: string): boolean {
  const [hit, setHit] = useState(() => hashIs(anchor));
  useEffect(() => {
    const update = () => setHit(hashIs(anchor));
    update();
    window.addEventListener("hashchange", update);
    return () => window.removeEventListener("hashchange", update);
  }, [anchor]);
  return hit;
}
